import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import SurplusResources34_3Table from "./Table";
import { ShowHide } from "../../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const SurplusResources34_3 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("SURPLUS_RESOURCES_FROM_MANUFACTURE") || "Surplus Resources from Manufacture"}
        subDescription={t("SURPLUS_RESOURCES_34_3_DESC") || "Enter surplus resources and disposal methods"}
        isNormal={true}
        number={"34.3"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`surplus-resources-34-3-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <SurplusResources34_3Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default SurplusResources34_3;
